module.exports = __webpack_public_path__ + "static/media/nosotros.dcb09aae.png";